import { render, staticRenderFns } from "./VisitRecordForm.vue?vue&type=template&id=9af10050&scoped=true"
import script from "./VisitRecordForm.vue?vue&type=script&lang=js"
export * from "./VisitRecordForm.vue?vue&type=script&lang=js"
import style0 from "./VisitRecordForm.vue?vue&type=style&index=0&id=9af10050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af10050",
  null
  
)

export default component.exports